import React from 'react';
// import { FormTextInput } from 'routes/auth/style';/*  */
import styled from 'styled-components';
import { H3 } from 'components/typography';
import { H2, H4 } from 'components/typography';
import Form from 'components/form';
import { WithMargin } from 'components/layout';
import { useTranslation } from 'i18n';
import { useUserApi } from 'services/user-service';
import { useHistory } from 'react-router-dom';
import { useLocalState } from 'state';
import { object, string } from 'yup';
import storage from 'services/storage';
import { toast } from 'services/toast';
import { useLocation } from 'react-router';
import { useParams } from 'react-router';

import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';
import { FileInput } from 'routes/surface/components/node-modal-form/style';

import surfaceNodeQuery from 'graphql/surface-node/queries/upload';

import { ReactComponent as LogoIcon } from 'styles/icons/logo.svg';

// import { templates } from '../../../routes/index';

// import React from 'react';
// import styled from 'styled-components';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// export default UploadedMessage;

// import DocumentNodeForm from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form';
// import UploadFileForm from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form/components/upload-file-form';
// import ImageNodeForm from 'routes/surface/components/node-modal-form/components/image-node-modal/components/image-node-form';
// import If from 'components/if-statement';
import useSaveSurfaceDocumentNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-document-node';
import useSaveSurfaceImageNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-image-node';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useFileToLocalUrl from 'hooks/use-file-to-local-url';
import { useUploadSurfaceNodeFile } from 'components/canvas/hooks/use-upload-surface-node-file';
// import { useTranslation } from 'i18n';
// import { withModal } from 'hoc';
import { asyncAction } from 'utils/js';
import { set } from 'lodash/fp';
// import { toast } from 'services/toast';
// import { ModalContext } from 'hoc/with-modal';

import useMutation from 'hooks/use-mutation';
import { addSurfaceNodeToSurfaceProtocolNodeMutation } from 'graphql/surface-node/mutations/surface-protocol-node/add-surface-node-to-surface-protocol-node';
import { SurfaceNodeUnion, SurfaceProtocolNode } from 'graphql/types';
import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node';
import axios from 'axios';
// import rest from 'services/http/rest';
import {
  SurfaceDocumentNode,
  SurfaceDocumentNodeFormat,
  SurfaceImageNodeFormat,
  SurfaceNodeType,
} from 'graphql/types';
import { NodeModalInput } from 'types';
import { Field, FormikProps } from 'formik';
import Axios from 'axios';
import {
  HeaderStyledLogoIconImmo,
  HeaderStyledLogoIconImmoText,
  HeaderStyledLogoIconImmoTextTop,
} from 'routes/list';
import { Div, querstionairesQuery } from 'routes/listDetail';
import { Container } from '@material-ui/core';
import Box from '@mui/material/Box';
import { useQuery } from '@apollo/client';
import { useMediaQuery } from '@mui/material';
import { withPortratitGuard } from './guard';
import { useTheme } from 'styled-components';
// import { Box } from '@material-ui/core';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  background-color: #f3f3f3;
  border-radius: 10px;
  padding: 20px;
`;

const StyledText = styled.h2`
  margin: 0;
  margin-left: 10px;
`;

const StyledSVG = styled.svg`
  fill: green;
  width: 50px;
  height: 50px;
`;

const UploadedMessage = ({ t }) => {
  return (
    <StyledWrapper>
      <StyledContent>
        <StyledSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17l-4.17-4.17L3 13l6 6 12-12-1.41-1.42L9 16.17z" />
        </StyledSVG>
        <H2>{t(`Daten erfolgreich hochgeladen.`)}</H2>
      </StyledContent>
    </StyledWrapper>
  );
};

export const HeaderStyledLogoIcon = styled(LogoIcon)`
  padding: 16px;
  position: relative;
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 56px;
  background-color: white;
`;

export const Text = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  /* height: 46px; */
  background-color: #3afa0020;
  color: #333333;
  border-radius: 3px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-right: 60px;
  padding-left: 8px;
`;

export const Label = styled.div`
  position: relative;
  width: 90%;
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
  margin-right: 100px;
  padding-right: -40px;
  /* background-color: #ccc; */
  /* padding: 8px; */
`;

export const Error = styled.div`
  position: relative;
  width: 90%;
  margin-bottom: 10px;
  font-size: 14px;
  color: #7c1a1a;
  margin-right: 100px;
  padding-right: -40px;
  /* background-color: #ccc; */
  /* padding: 8px; */
`;

const LabelText = ({ entry }) => {
  // console.log('Entry', entry);
  const reqired = entry.required ? ' * ' : '';
  return (
    <Label className="text-sm">
      {entry.question}
      {reqired}
    </Label>
  );
};
export const FileInput2 = styled(FileInput)`
  height: 140px;
`;

function createValidationSchema(t) {
  return function () {
    return object().shape({
      email: string().required(t('Email is required.')),
      password: string()
        .required(t('No password provided'))
        .min(5, t('Password is too short - should be 5 chars minimum.')),
    });
  };
}

export const FormTextInput = styled(Form.TextInput)`
  /* width: 100%; */
  height: 60px;
  font-size: ${typography.size.md};
`;

export const Overlay = styled.div`
  background-color: ${color.brand.greenDarkWithOpacity(0.3)};
  width: 100vw;
  height: 100vh;
  overflow: none;
  position: relative;
`;

// export const Container = styled.div`
//   background-color: ${color.neutral.white};
//   margin: 0;
//   position: absolute;
//   top: 53%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   padding: ${normalize('24px')} ${normalize('32px')};
//   max-width: 1600px;
// `;

export const Container2 = styled.div`
  /* background-color: ${color.neutral.white};
  margin: 0;
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${normalize('24px')} ${normalize('32px')};
  max-width: 1600px; */
  margin-bottom: 20px;
`;

export const Div2 = styled.div`
  /* background-color: red; */
  height: 100vh;
  background: ${({ theme }) => theme.background};
  padding-top: 5vh;
  /* position: absolute; */
`;

function Template() {
  const { t } = useTranslation();
  const location = useLocation();
  const { setToState } = useLocalState();
  const userApi = useUserApi();

  const [status, setStatus] = React.useState<any>();
  const [errorState, setError] = React.useState<any>();

  const { key, surface } = useParams<{ key: string; surface: string }>();

  // const template = templates.find((t) => t.id == key);

  const history = useHistory();

  const theme = useTheme();

  const email = new URLSearchParams(location.search).get('email');

  async function onSubmitX({ email, password }) {
    console.log('ON SUBMIT ', email);
    /*     const response = await userApi.adminLogin(email, password);

    if (response.isSuccess) {
      const adminToken = response.getField('data.token');
      const user = response.getField('data.user');

      await setToState({ user });

      await storage.setAdminToken(adminToken);

      return history.push('/admin/sign-in-code/list');
    } */

    toast.error('Not Implemented');
  }

  const dates = {
    data2: {
      userName: 'Test User 2',
      name: 'Other Placehoder Name',
      comment:
        ' Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor ',
      accept: ['jpeg', 'pdf'],
    },
    data: {
      userName: 'Bernd Bergler',
      // name: 'Placehoder Name',
      // comment: ' kommentar 1 ',
      accept: ['jpeg', 'pdf'],
    },
    test: {
      userName: 'Test User One',
      name: 'Placehoder Name',
      comment: ' kommentar 1 ',
      accept: ['jpeg', 'pdf'],
    },
  };

  const data = dates['data'];

  //const saveNodeInCache = useSaveNodeInCache();
  // const saveSurfaceDocumentNode = useSaveSurfaceDocumentNode(
  //   data?.surfaceId || '',
  // );
  // const saveSurfaceImageNode = useSaveSurfaceImageNode(data?.surfaceId || '');
  // const uploadFile = useUploadSurfaceNodeFile(data?.surfaceId || '');

  function getFileFormat(file): string | undefined {
    if (file?.type.includes('pdf')) {
      return SurfaceDocumentNodeFormat.Pdf;
    }

    if (file?.type.includes('jpg')) {
      return SurfaceImageNodeFormat.Jpg;
    }

    if (file?.type.includes('jpeg')) {
      return SurfaceImageNodeFormat.Jpeg;
    }

    if (file?.type.includes('png')) {
      return SurfaceImageNodeFormat.Png;
    }
  }

  const [addSurfaceNodeToSurfaceProtocolNode] = useMutation(
    addSurfaceNodeToSurfaceProtocolNodeMutation,
  );

  //

  async function onSubmit(data) {
    console.log(' XXXXX ', data);
    var keys = Object.keys(data);

    const entr = Object.entries(data).map((entry) => {
      // console.log('FILE', entry[1], entry instanceof File);
      if (entry[1].name) {
        const fileObject = entry[1];
        const fileData = {
          lastModified: fileObject.lastModified,
          // lastModifiedDate: fileObject.lastModifiedDate,
          name: fileObject.name,
          size: fileObject.size,
          type: fileObject.type,
        };
        return [entry[0], fileData];
      }
      return entry;
    });

    const data2 = Object.fromEntries(entr);

    const x = JSON.stringify(data);
    console.log(' XXXXX1  ', data2);
    var requiredFields = template
      .filter((t) => t.type != 'hint')
      .filter((t) => t.required)
      .map((t) => t.id);
    const allrequired = requiredFields.every(
      (v) => keys.includes(v) && data[v] !== '',
    );
    if (!allrequired) {
      console.log(
        'required',
        allrequired,
        keys,
        template.filter((t) => t.required),
      );
      setError('Bitte alle erforderlichen Felder Ausfüllen.');
      return;
    }

    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/v1/users/template`,
      data: {
        ...data2,
        key,
        surface,
        // name: 'Bernd Bergler',
      },
    });

    console.log('RESP:, ', response);
    const { uploads } = response.data.data;
    const uploadP = Object.entries(uploads).map(async (entry) => {
      const id = entry[0];
      const url = entry[1];
      const f = data[id];
      console.log('FILE UPLOAS:, ', f);

      const config = {
        /*params: {
            Key: values.name,
            ContentType
          },*/
        headers: {
          Accept: '*/*',
          'Content-Type': f.type,
        },
        // onUploadProgress: onProgress
      };

      const response = await axios.put(url, f, config);
    });
    await Promise.all(uploadP);

    if (response.status == 200) {
      setStatus('uploaded');
    }
    // setData('uploaded');

    // console.log(' XXXXX ', data.pos);
    // if (input.comment == undefined) {
    //   toast.error('Kommentar ist benötigt');
    //   return;
    // }
    // if (input.file == undefined) {
    //   toast.error('Datei ist benötigt');
    //   return;
    // }
    // const inp = {
    //   format: getFileFormat(input.file),
    //   name: input.comment,
    //   position: data.position,
    //   surface: data?.surfaceId,
    //   // url: "blob:https://my.cortlex.at/688653f4-d921-4563-a992-e7440990abdd"
    // };
    // const isDocument =
    //   input?.file?.type.includes('pdf') ||
    //   input?.type === SurfaceNodeType.Document;
    // const saveOperation = isDocument
    //   ? saveSurfaceDocumentNode
    //   : saveSurfaceImageNode;
    // console.log('AAAA 1');
    // const response2 = await saveOperation({ variables: { input: inp } });
    // console.log('AAAA 2', response2);
    // if (response2.isFailure) {
    //   //setSubmitting(false);
    //   console.error(response2.getErrorMessage());
    //   toast.error(response2.getErrorMessage());
    //   return response2;
    // }
    // console.log('AAAA');
    // const node = response2.getField('data');
    // console.log('AAAA', node);
    // // Upload a file  then set correct values and submit data
    // const [error] = await asyncAction(uploadFile(input.file, node.id));
    // const inputProt = {
    //   node: node.id,
    //   protocolNode: data.id,
    // };
    // const position = {
    //   //@ts-ignore
    //   x: data?.position?.x + PROTOCOL_PADDING,
    //   //@ts-ignore
    //   y: data?.position?.y + PROTOCOL_PADDING,
    // };
    // const response3 = await addSurfaceNodeToSurfaceProtocolNode({
    //   variables: {
    //     input: inputProt,
    //     positionInput: { nodeId: data.id, position },
    //   },
    // });
    // console.log('AAAA 2', response3);
    // if (response3.isFailure) {
    //   //setSubmitting(false);
    //   console.error(response3.getErrorMessage());
    //   toast.error(response3.getErrorMessage());
    //   return response2;
    // }
    // // if (error) {
    // //   Sentry.captureException(error);
    // // }
    // // saveNodeInCache(set('updatedAt', new Date().toISOString(), node));
    // // setData('uploaded');
    // return response2;
  }

  const initialValues = {
    // email: email || '',
    // password: '',
    // ...data,
    // //file,
    // name: data.name,
    // format: getFileFormat(file),
    // ...(file ? { type, url: fileUrl } : {}),
  };

  const validationSchema = createValidationSchema(t);

  // const dates = {
  //   data2: {
  //     userName: 'Test User 2',
  //     name: 'Other Placehoder Name',
  //     comment:
  //       ' Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor ',
  //     accept: ['jpeg', 'pdf'],
  //   },
  //   data: {
  //     userName: 'Test User One',
  //     name: 'Placehoder Name',
  //     comment: ' kommentar 1 ',
  //     accept: ['jpeg', 'pdf'],
  //   },
  //   test: {
  //     userName: 'Test User One',
  //     name: 'Placehoder Name',
  //     comment: ' kommentar 1 ',
  //     accept: ['jpeg', 'pdf'],
  //   },
  // };

  // React.useEffect(() => {
  //   console.log('XXX USE1');
  //   (async function () {
  //     console.log('XXX USE2');
  //     const data = await surfaceNodeQuery({
  //       id: key,
  //     });
  //     let map = {
  //       '6078928ce3ce4f1b802cb958f6afde1f': 'BBErnd',
  //       // "6078928ce3ce4f1b802cb958f6afde1f": ""
  //       '601daa2575f44626b92b9b2dca36d6b9': 'Niki Ochsenhofer',
  //       '6022acdf3100467e88e6e0322e93b6c9': 'Max Ochsenhofer',
  //       '602fcd0c3cd94d659d9d0f0c13dde081': 'Max Ochsenhofer',
  //       '6078928c8b6a45e39c39f70436672dd3': 'Niki Ochsenhofer',
  //       '603e6110761a45a68c8b5f90e1d2aedc': 'office account',
  //     };

  //     console.warn('DATA', data.data.data);
  //     console.warn('DATA POS', data.data.data.position);
  //     if (data.data.data)
  //       if (!data.data.data.contains) {
  //         setData({
  //           id: data.data.data.id,
  //           surfaceId: data.data.data.surface.id,
  //           userName: map[data.data.data.ownedBy] || '-',
  //           name: data.data.data.name,
  //           comment: data.data.data.uploadComment,
  //           position: data.data.data.position,
  //           accept: ['jpeg', 'pdf'],
  //         });
  //       }
  //   })();
  // }, []);

  // if (data == undefined) {
  //   return (
  //     <WithMargin bottom={typography.size.xl}>
  //       <H2>{t(`Daten hochladen nicht mehr möglich.`)}</H2>
  //     </WithMargin>
  //   );
  // }

  const { loading: loadingQ, error, data: q } = useQuery(querstionairesQuery, {
    variables: { id: surface },
    fetchPolicy: 'network-only',
  });

  const isMobile = useMediaQuery('(max-width:600px)');
  if (loadingQ) {
    return 'LOADING';
  }

  if (status == 'uploaded') {
    return (
      // <WithMargin bottom={typography.size.xl}>
      //   <H2>{t(`Daten erfolgreich hochgeladen.`)}</H2>
      // </WithMargin>
      <UploadedMessage t={t}> </UploadedMessage>
    );
  }
  let questionnaire = q.questionnaireForSurface.data;
  let quest = [...questionnaire.questions];
  const template = quest.sort((a, b) => {
    return a.order - b.order;
  });

  console.log('TEMPLATE', template);

  function renderTemplate(form: FormikProps<any>) {
    return (
      <>
        {template
          ?.map((entry) => {
            if (entry.type == 'hint') {
              return <Text> {entry.question} </Text>;
            }
            if (entry.type == 'text' || entry.type == 'QUESTION2') {
              {
                /* <FileInput
                  name="file"
                  //onChange={props.onFileChange}
                  label={t('Select or drag {{types}} file', {
                    replace: { types: data.accept?.join(', ') },
                  })}
                  $hasFile={form.values.file}
                  accept={data.accept}
                />
                <FormTextInput name="comment" placeholder={t('Kommentar')} /> */
              }

              return (
                <>
                  <LabelText entry={entry} />

                  <FormTextInput name={entry.id} />
                </>
              );
            }

            if (entry.type == 'number') {
              return (
                <>
                  <LabelText entry={entry} />
                  <FormTextInput name={entry.id} type="number" />
                </>
              );
            }
            if (entry.type == 'boolean') {
              return (
                <>
                  {/* <Field
                  name="acceptTerms"
                  // className="mr-2 leading-tight"
                  type="checkbox"
                /> */}
                  <LabelText entry={entry} />
                  <Field component="div" name="myRadioGroup">
                    <input
                      type="radio"
                      id="radioOne"
                      // defaultChecked={values.myRadioGroup === "one"}
                      name={entry.id}
                      value="yes"
                    />
                    <label htmlFor="radioOne">Ja</label>

                    <input
                      type="radio"
                      id="radioTwo"
                      // defaultChecked={values.myRadioGroup === "two"}
                      name={entry.id}
                      value="no"
                    />
                    <label htmlFor="radioTwo">Nein</label>
                  </Field>
                </>
              );
            }
            if (entry.type == 'document') {
              return (
                <>
                  <LabelText entry={entry} />
                  <FileInput2
                    name={entry.id}
                    //onChange={props.onFileChange}
                    label={t('Select or drag {{types}} file', {
                      replace: { types: data.accept?.join(', ') },
                    })}
                    $hasFile={form.values.file}
                    accept={data.accept}
                  />
                </>
              );
            }
            return JSON.stringify(entry);
          })
          .map((element) => (
            <Container2> {element}</Container2>
          ))}
      </>
    );
  }
  return (
    <>
      <Div2>
        {/* <Header></Header> */}
        {/* <Container> */}
        <Container maxWidth="lg">
          {theme.name == 'cortlex' && <HeaderStyledLogoIcon />}
          {theme.name == 'immoox' && (
            <>
              <HeaderStyledLogoIconImmo />
              {isMobile && <HeaderStyledLogoIconImmoTextTop />}
              {!isMobile && <HeaderStyledLogoIconImmoText />}
            </>
          )}
          <Box
            component="div"
            sx={{
              mt: isMobile ? 7 : 0,
              display: 'flex',
              flexDirection: 'column',
              height: '75vh',
              overflow: 'hidden',
              overflowY: 'scroll',
              backgroundColor: 'lightgray',
              paddingY: isMobile ? 1 : 10,
              paddingX: isMobile ? 1 : 20,
            }}>
            <WithMargin bottom={typography.size.xl}>
              <H2>{t(`Beantworte folgende Fragen:`)}</H2>
            </WithMargin>
            {/* <WithMargin bottom={typography.size.xl}>
            <H2>{t(`Dokument: ${data.name}`)}</H2>
          </WithMargin> */}
            {/* {data.comment && (
            <WithMargin bottom={typography.size.xl}>
              <H3>{t(`Anmerkung:`)}</H3>
              <br />
              <H4>{t(`${data.comment}`)}</H4>
            </WithMargin>
          )} */}
            <Form
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={onSubmit}
              submitOnEnter>
              {(form) => (
                <>
                  <Label className="text-sm">{'Dein Name'}</Label>
                  <FormTextInput name="name" />
                  {renderTemplate(form)}
                  {/* <FileInput
                  name="file"
                  //onChange={props.onFileChange}
                  label={t('Select or drag {{types}} file', {
                    replace: { types: data.accept?.join(', ') },
                  })}
                  $hasFile={form.values.file}
                  accept={data.accept}
                />
                <FormTextInput name="comment" placeholder={t('Kommentar')} /> */}
                  {errorState && <Error>{errorState}</Error>}
                  <WithMargin bottom={typography.size.md}>
                    <Form.SubmitButton
                      label={t('Hochladen')}
                      onClick={form.handleSubmit}
                      loading
                    />
                  </WithMargin>
                  {/* 
              <Form.Button
                label={t('Not registered?')}
                onClick={() => history.push('/register')}
                link
              />

              <Form.Button
                label={t('Forgot password?')}
                onClick={() => history.push('/forgot-password')}
                link
              /> */}
                </>
              )}
            </Form>
          </Box>
        </Container>
      </Div2>
    </>
  );
}

export default withPortratitGuard(Template);
